var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    _vm._b(
      {
        model: {
          value: _vm.formValue,
          callback: function ($$v) {
            _vm.formValue = $$v
          },
          expression: "formValue",
        },
      },
      "v-dialog",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("extra"),
      _vm._v(" "),
      _vm.showCard
        ? _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._t("title")], 2),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.disableClose },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.close.apply(null, arguments)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.loading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("alert"),
              _vm._v(" "),
              _c("v-card-text", [_vm._t("text")], 2),
              _vm._v(" "),
              _c("v-card-actions", [_vm._t("actions")], 2),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }